import './polyfills';
import './css/croppr.css';
import Croppr from './croppr.js';
export default Croppr;